import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TrialInsightsTableService } from './trial-insights-table.service';
import {
  TrialInsightsTableChangeKeyFn,
  TrialInsightsTableOptions,
  TrialInsightsTableRowData,
  TrialInsightsTableToggleOrderFn,
} from '../../models/trial-insights-table.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink],
  selector: 'aux-trial-insights-table',
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './trial-insights-table.component.html',
})
export class TrialInsightsTableComponent implements OnInit {
  tableService = inject(TrialInsightsTableService);

  @Input() changeSelectedKey!: TrialInsightsTableChangeKeyFn;
  @Input() isLoadingRemaining!: boolean;
  @Input() options!: TrialInsightsTableOptions;
  @Input() selectedKey!: string;
  @Input() sortOrder!: string;
  @Input() toggleSortOrder!: TrialInsightsTableToggleOrderFn;

  ngOnInit(): void {
    this.selectedKey = this.options.buttons.defaultButtonKey;
  }

  get headers(): [string, string] {
    const headers = this.options.header.data;

    return this.tableService.headers(headers, this.selectedKey);
  }

  get rowData(): TrialInsightsTableRowData[] {
    const rowData = this.options.rowData.data;

    return this.tableService.rowData(rowData, this.selectedKey);
  }

  select(buttonKey: string): void {
    this.changeSelectedKey(buttonKey);
  }

  sort(): void {
    if (this.isLoadingRemaining) {
      return;
    }

    this.toggleSortOrder();
  }
}
